import { SyntheticEvent } from 'react';
import { browserHistory } from 'react-router';
import { Tabs, Tab } from '@mui/material';

const TABS = [
  { value: 'drafts', label: 'Drafts' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'published', label: 'Published' },
  { value: 'archived', label: 'Archived' },
] as const;

type WorkoutsTabsProps = {
  creatorId: number;
};

export const WorkoutsTabs = ({ creatorId }: WorkoutsTabsProps) => {
  const activeTab =
    TABS.find((tab) => window.location.href.includes(tab.value))?.value ??
    'published';

  const handleChange = (_event: SyntheticEvent, value: string) => {
    browserHistory.push(`/admin/partner/${creatorId}/workouts/${value}`);
  };

  return (
    <Tabs value={activeTab} onChange={handleChange} variant="scrollable">
      {TABS.map((tab) => (
        <Tab
          key={tab.value}
          value={tab.value}
          label={tab.label}
          sx={{ fontSize: '1.1rem', fontWeight: 600 }}
        />
      ))}
    </Tabs>
  );
};
